<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">

      <b>操作人IP：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.para1"
                placeholder="操作人IP"/>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>
    </div>
    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column label="登录账号" prop="userId" align="center"></el-table-column>
      <el-table-column label="登录ip" prop="ipAddress" align="center"></el-table-column>
      <el-table-column label="登录状态" prop="loginStatus" align="center"  >
        <template slot-scope="scope">
          {{scope.row.loginStatus===0 ?'失败':'成功' }}
        </template>
      </el-table-column>
      <el-table-column label="登录时间" prop="loginTime" :formatter="formatDate" align="center">
      </el-table-column>
    </el-table>
    <template>
      <div>

        <pagination
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>





  </div>

</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    return {
      file1src: '',
      total: 0,
      pid: '',
      scinfo: {
        id: '',
        scstate: '',
        opinion: ''
      },
      projecttypes: [],
      pwfileList: [],
      form: {
        operParam: '',
        jsonResult: ''
      },
      dialogpdfVisibledel: false,

      createvueVisible: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        para1: undefined,
        para2: undefined
      },
      selectTable: {
        title: '新增权限',
        id: 0,
        role: '',
        rolename: '',
        defalutCheckArr: [],
        rptid: 0
      },
      statusList:[{status: 1,level:'成功'},{status: 0,level:'失败'}],
      defaultProps: {
        children: "children",
        label: "pname"
      },
      // 菜单列表
      dialogFormVisible: false,
      dialogFormData: [],
      tableData: [],
      DicData: [],
      tablelistData: [],
      search: '',
      loading: false
    }
  },
  mounted() {
    this.getList();

  },
  methods: {
    formatDate(row) {
      const timestamp = row.loginTime;
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();

      const formattedDate = `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day} ${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}:${seconds < 10 ? '0' + seconds : seconds}`;

      return formattedDate;
    },
    cleardata(){
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/system/loginLoglist",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },


  },
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}

/*#roleListpage .el-pager li.active {
  color: white;
}*/

#pdfdialog .el-dialog--small {
  top: 3% !important;
  width: 86% !important;
  height: 93% !important;
}

#scfrom .el-input.is-disabled .el-input__inner {
  background-color: white;
  border-color: white;
  color: #4e4e59;
  padding-bottom: 4px;
}

#scfrom .el-textarea.is-disabled .el-textarea__inner {
  background-color: white;
  border-color: #C0C4CC;
  color: #4e4e59;
  padding-bottom: 4px;
}
</style>